import { template as template_b7e1a51eb8654ffabdaf6f04dbdd8bd5 } from "@ember/template-compiler";
import PendingInsuranceInfoBanner from './pending-insurance-info-banner';
import RejectedRequests from './rejected-requests';
import styles from './submission-notifications.module.scss';
export default template_b7e1a51eb8654ffabdaf6f04dbdd8bd5(`
  <div class={{styles.component}}>
    {{#if @pendingInsuranceRequests}}
      <PendingInsuranceInfoBanner @pendingInsuranceInfoCount={{@pendingInsuranceRequests.length}} />
    {{/if}}
    {{#if @rejectedInsuranceRequests}}
      <RejectedRequests @rejectedInsuranceRequests={{@rejectedInsuranceRequests}} />
    {{/if}}
  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
